import { render, staticRenderFns } from "./OpportunityDocumentsQueueState.vue?vue&type=template&id=5d12b393&scoped=true"
import script from "./OpportunityDocumentsQueueState.vue?vue&type=script&lang=js"
export * from "./OpportunityDocumentsQueueState.vue?vue&type=script&lang=js"
import style0 from "./OpportunityDocumentsQueueState.vue?vue&type=style&index=0&id=5d12b393&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d12b393",
  null
  
)

export default component.exports